import axios from "axios";

const activeLive = false;
const livesURL =
  "https://conferencias.ministeriofiel.com.br/endpoints/live/index.php";
const queryOptions = {
  evento_id: 200094,
  chave:
    "VGltZSBpcyB3aGF0IGRldGVybWluZXMgc2VjdXJpdHkuIFdpdGggZW5vdWdoIHRpbWUgbm90aGluZyBpcyB1bmhhY2thYmxlLg==",
};

export default {
  getLivesMF(context) {
    if (activeLive === true) {
      return new Promise((resolve, reject) => {
        axios
          .get(livesURL, { params: queryOptions })
          .then((response) => {
            context.commit("setLivesMF", response.data);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
    if (activeLive === false) {
      context.commit("setLivesMF", false);
    }
    return false;
  },
};
